import { alpha } from '@mui/material/styles';
import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

import LAYOUT_SIZES from 'constants/styles/LAYOUT_SIZES';

type StyleParams = {
  showIndicator: boolean;
};

const ringBell = keyframes`
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  1% { transform: translate(-50%, -50%) rotate(10deg); }
  5% { transform: translate(-50%, -50%) rotate(-10deg); }
  10% { transform: translate(-50%, -50%) rotate(10deg); }
  15% { transform: translate(-50%, -50%) rotate(-10deg); }
  20% { transform: translate(-50%, -50%) rotate(0); }
  100% { transform: translate(-50%, -50%) rotate(0); }
`;

const useStyles = makeStyles<StyleParams>()((theme, { showIndicator }) => {
  const pulse = keyframes`
    0% { box-shadow: 0 0 0 0 ${alpha(theme.palette.custom.red, 0.9)}; }
    100% { box-shadow: 0 0 0 7px ${alpha(theme.palette.custom.red, 0)}; }
  `;

  return {
    container: {
      position: 'relative',

      height: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(9)})`,
      width: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(9)})`,

      border: 'none',
      background: 'none',
      marginLeft: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
    indicator: {
      position: 'absolute',
      top: '5%',
      right: '12%',
      height: '30%',
      width: '30%',
      borderRadius: '100px',
      zIndex: 1,
      background: theme.palette.custom.red,
      transition: theme.transitions.create(['transform'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      transform: `scale(${showIndicator ? 1 : 0})`,
      animation: `${pulse} 1800ms infinite`,
    },
    icon: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      height: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(9)})`,
      width: `calc(${LAYOUT_SIZES.HEADER.md}px - ${theme.spacing(9)})`,
      transformOrigin: 'top center',
      animation: `${ringBell} 6s infinite`,
      animationPlayState: showIndicator ? 'running' : 'paused',
      animationFillMode: 'forwards',
    },
  };
});

export default useStyles;
